import { render, staticRenderFns } from "./actCollectionRecords.vue?vue&type=template&id=91b0fe10"
import script from "./actCollectionRecords.vue?vue&type=script&lang=js"
export * from "./actCollectionRecords.vue?vue&type=script&lang=js"
import style0 from "./actCollectionRecords.vue?vue&type=style&index=0&id=91b0fe10&prod&lang=scss"
import style1 from "./actCollectionRecords.vue?vue&type=style&index=1&id=91b0fe10&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports